import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["attributes", "bounds"],
  _excluded2 = ["children"];
import { createElementHook, createElementObject, createLayerHook, updateMediaOverlay } from '@react-leaflet/core';
import { SVGOverlay as LeafletSVGOverlay } from 'leaflet';
import { forwardRef, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';
export var useSVGOverlayElement = createElementHook(function createSVGOverlay(props, context) {
  var attributes = props.attributes,
    bounds = props.bounds,
    options = _objectWithoutProperties(props, _excluded);
  var container = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  container.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  if (attributes != null) {
    Object.keys(attributes).forEach(function (name) {
      container.setAttribute(name, attributes[name]);
    });
  }
  var overlay = new LeafletSVGOverlay(container, bounds, options);
  return createElementObject(overlay, context, container);
}, updateMediaOverlay);
export var useSVGOverlay = createLayerHook(useSVGOverlayElement);
function SVGOverlayComponent(_ref, forwardedRef) {
  var children = _ref.children,
    options = _objectWithoutProperties(_ref, _excluded2);
  var _useSVGOverlay$curren = useSVGOverlay(options).current,
    instance = _useSVGOverlay$curren.instance,
    container = _useSVGOverlay$curren.container;
  useImperativeHandle(forwardedRef, function () {
    return instance;
  });
  return container == null || children == null ? null : /*#__PURE__*/createPortal(children, container);
}
export var SVGOverlay = /*#__PURE__*/forwardRef(SVGOverlayComponent);